import {
  Badge,
  SystemStyleObject,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'

import { OrganizationUnitGridItem } from 'BrokerTsLib/src/dtos'
import { useContext } from 'react'
import { ValidityBadge } from '../shared/ValidityBadge'
import { OrganizationLink } from '../shared/OrganizationLink'
import { ColumnDefinition, ColumnsDefinition } from 'BrokerTsLib/src/interfaces/columnsDefinition'
import { getOrganizationUnitTypeName } from 'brokertslib/src/enums'
import { Ellipsis, EmptyTablePlaceholder, TableSkeleton } from 'brokertslib/src/components'
import { organizationListContext } from 'brokertslib/src/context'

export const OrganizationListNameColumn: ColumnDefinition<OrganizationUnitGridItem>
  = { key: 'name', name: 'Organizace', cellExpr: (item) => <OrganizationLink sx={{ color: 'primary.500', fontWeight: 'medium' }} id={item.id} name={item.name} /> }

export const OrganizationListSuperiorOrganizationColumn: ColumnDefinition<OrganizationUnitGridItem>
  = { key: 'superiorOrganizationUnitName', name: 'Nadřízená organizace', cellExpr: (item) => <OrganizationLink sx={{ color: 'primary.500' }} id={item.superiorOrganizationUnitId} name={item.superiorOrganizationUnitName} /> }

export const OrganizationListContactPersonColumn: ColumnDefinition<OrganizationUnitGridItem>
  = { key: 'contactPerson', name: 'Kontaktní osoba', cellExpr: (item) => <Ellipsis><Text sx={{ fontWeight: 'medium' }}>{item.contactName}</Text></Ellipsis> }

export const OrganizationListCityColumn: ColumnDefinition<OrganizationUnitGridItem>
  = { key: 'municipality', name: 'Obec', cellExpr: (item) => <Ellipsis>{item.addressCity}</Ellipsis> }

export const OrganizationListDescriptionColumn: ColumnDefinition<OrganizationUnitGridItem>
  = { key: 'description', name: 'Popis', cellExpr: (item) => <Ellipsis fontSize='sm'>{item.description}</Ellipsis> }

export const OrganizationListValidColumn: ColumnDefinition<OrganizationUnitGridItem>
  = { key: 'valid', name: '', cellExpr: (item) => <ValidityBadge valid={item.valid} /> }

export const OrganizationListTypeColumn: ColumnDefinition<OrganizationUnitGridItem>
  = { key: 'type', name: '', cellExpr: (item) => item.type ? <Badge colorScheme="blue">{getOrganizationUnitTypeName(item.type)}</Badge> : '' }

export const OrganizationListDefaultColumns: ColumnsDefinition<OrganizationUnitGridItem> = [
  OrganizationListNameColumn,
  OrganizationListSuperiorOrganizationColumn,
  OrganizationListContactPersonColumn,
  OrganizationListCityColumn,
  OrganizationListDescriptionColumn,
  { ...OrganizationListValidColumn, cellProps: { pr: 1 } },
  { ...OrganizationListTypeColumn, cellProps: { pl: 0 } }
]

export const OrganizationsList = ({
  organizations,
  sx,
  columnsDefinition = OrganizationListDefaultColumns
}: {
  organizations: Array<OrganizationUnitGridItem>
  withPaginator?: boolean
  sx?: SystemStyleObject
  columnsDefinition?: ColumnsDefinition<OrganizationUnitGridItem>
}) => {
  const { pageSize, loading } = useContext(organizationListContext)

  return (
    <Table variant="striped" sx={sx}>
      <Thead>
        <Tr>
          {columnsDefinition && columnsDefinition.map(column => (<Th key={column.key} _empty={{ w: 0, p: 0 }} {...column.headerCellProps}>{column.name}</Th>))}
        </Tr>
      </Thead>

      <Tbody>
        <TableSkeleton rowsCount={pageSize} colSpan={columnsDefinition.length} isLoaded={!loading} >
          <EmptyTablePlaceholder text={'Žádné organizace k zobrazení'} colSpan={columnsDefinition.length}>{
            organizations.map(organization => {
              return (
                <Tr key={organization.id}>
                  {columnsDefinition && columnsDefinition.map(column =>
                    <Td key={column.key} _empty={{ p: 0 }} {...column.cellProps}>
                      {column.cellExpr(organization) || ''}
                    </Td>
                  )}
                </Tr>
              )
            })}
          </EmptyTablePlaceholder>
        </TableSkeleton>
      </Tbody>
    </Table >
  )
}
